import type {ActionLotties} from './action/actionLotties';

type LottieFile = string;

interface LottiePack {
  [key: string]: LottieFile;
}

type ImportFunction = () => Promise<{lottiesPack: LottiePack}>;

const lottieLoaderFactory =
  <T extends string>(importFn: ImportFunction, icon: T) =>
  () =>
    importFn().then((module) => module.lottiesPack[icon]);

const loadActionLottie = (icon: ActionLotties) =>
  lottieLoaderFactory(() => import('./action/actionLotties'), icon);

export const themeLottie = {
  'action/ai_robot': loadActionLottie('action/ai_robot'),
  'action/done': loadActionLottie('action/done'),
} as const;
